import { render, staticRenderFns } from "./deleteDesignModal.vue?vue&type=template&id=59a1151b&"
import script from "./deleteDesignModal.vue?vue&type=script&lang=ts&"
export * from "./deleteDesignModal.vue?vue&type=script&lang=ts&"
import style0 from "./deleteDesignModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports